
export class PaymenthistoryRequest {
        public agreementNumber : string
        public scheduleNumber: number
        public startDate : string
        public endDate : string
}
